export default __webpack_public_path__ + "static/media/genMutation.3dd002ca.png";